'use client';

import { c as _c } from "react/compiler-runtime";
import { Sort } from '@sprd/sprd-component-kit/v2';
import { useCallback, useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import { SortFilterContent } from '@/components/Filters/FilterContent';
import { FilterDropdown } from '@/components/Filters/FilterDropdown';
type SortFilterDropdownProps = {
  sortOptions: Record<string, string>;
  selected?: string;
  defaultSort: string;
  onChange: (sort: string | undefined) => void;
};
export const SortFilterDropdown = t0 => {
  const $ = _c(27);
  const {
    sortOptions,
    selected,
    defaultSort,
    onChange
  } = t0;
  const t = useTranslations();
  const [localSelected, setLocalSelected] = useState(selected ?? defaultSort);
  let t1;
  let t2;
  if ($[0] !== defaultSort || $[1] !== selected) {
    t1 = () => {
      setLocalSelected(selected ?? defaultSort);
    };
    t2 = [selected, defaultSort];
    $[0] = defaultSort;
    $[1] = selected;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== defaultSort || $[5] !== onChange) {
    t3 = () => {
      setLocalSelected(defaultSort);
      onChange(undefined);
    };
    $[4] = defaultSort;
    $[5] = onChange;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleReset = t3;
  let t4;
  if ($[7] !== defaultSort || $[8] !== localSelected || $[9] !== onChange) {
    t4 = () => {
      onChange(localSelected === defaultSort ? undefined : localSelected);
    };
    $[7] = defaultSort;
    $[8] = localSelected;
    $[9] = onChange;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleShowProducts = t4;
  const hasChanges = localSelected !== (selected ?? defaultSort);
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Sort className="size-4" />;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("filter.sort.sortBy");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <>{t5}<span>{t6}</span></>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = !!selected && selected !== defaultSort ? 1 : 0;
  const t9 = !selected || selected === defaultSort;
  const t10 = !hasChanges;
  let t11;
  if ($[16] !== localSelected || $[17] !== sortOptions) {
    t11 = <SortFilterContent className="*:py-2" onChange={setLocalSelected} selectedOption={localSelected} sortOptions={sortOptions} />;
    $[16] = localSelected;
    $[17] = sortOptions;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== handleReset || $[20] !== handleShowProducts || $[21] !== t10 || $[22] !== t11 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9) {
    t12 = <FilterDropdown filterLabel={t7} selectedCount={t8} onReset={handleReset} onShowProducts={handleShowProducts} resetDisabled={t9} showProductsDisabled={t10} dropdownContent={t11} />;
    $[19] = handleReset;
    $[20] = handleShowProducts;
    $[21] = t10;
    $[22] = t11;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};